const selfSelector = (state) => state.rejectsReport;

export default selfSelector;
